import { useMemo } from 'react';
import type { CMSTournamentGame } from '@/api/cms/restrictions';
import { filterByGroupAndDuration } from '@/helpers/cms';
import { useGetCommonStore } from '@/store';
import { parseCommaSeparated } from '../../tournaments/helpers';
import { useCMSConfig } from './useCMSConfig';

export const useTournamentGames = () => {
  const useCommonStore = useGetCommonStore();
  const user = useCommonStore.use.user();
  const { tournamentGames } = useCMSConfig();

  const currentTournamentGames = useMemo(
    () =>
      filterByGroupAndDuration<CMSTournamentGame>({ user })(tournamentGames),
    [tournamentGames, user]
  );

  const { tournamentGameCategories, tournamentGameIds } = useMemo(() => {
    if (!currentTournamentGames.length) {
      return {
        tournamentGameCategories: [],
        tournamentGameIds: [],
      };
    }

    return {
      tournamentGameCategories: currentTournamentGames.flatMap((section) =>
        parseCommaSeparated(section?.tournamentGameCategories)
      ),
      tournamentGameIds: currentTournamentGames.flatMap((section) =>
        parseCommaSeparated(section?.tournamentGameIds)
      ),
    };
  }, [currentTournamentGames]);

  return {
    tournamentGameCategories,
    tournamentGameIds,
  };
};
